var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C27.94 0 36 8.06 36 18C36 27.94 27.94 36 18 36C8.06 36 0 27.945 0 18C0 8.055 8.06 0 18 0Z",
    fill: "#26A17B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5346 15.9929V13.3129H26.6596V9.23291H9.98453V13.3129H16.1096V15.9929C11.1345 16.2229 7.38953 17.2079 7.38953 18.3879C7.38953 19.5679 11.1345 20.5529 16.1096 20.7829V29.3579H20.5396V20.7829C25.5096 20.5529 29.2446 19.5679 29.2446 18.3879C29.2396 17.2079 25.5046 16.2229 20.5346 15.9929ZM20.5396 20.0579C20.4146 20.0629 19.7746 20.1029 18.3446 20.1029C17.1996 20.1029 16.3996 20.0729 16.1146 20.0579V20.0629C11.7195 19.8679 8.43453 19.1029 8.43453 18.1879C8.43453 17.2729 11.7145 16.5079 16.1146 16.3129V19.2929C16.4046 19.3129 17.2246 19.3629 18.3646 19.3629C19.7296 19.3629 20.4146 19.3079 20.5446 19.2929V16.3029C24.9346 16.4979 28.2096 17.2629 28.2096 18.1779C28.1996 19.0929 24.9246 19.8579 20.5396 20.0579Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.7d7ed9ddf84421e3349e970572347cfb.svg";
export { ForwardRef as ReactComponent };